import vbApiService from "@/shared/services/vbApiService";
import { RecaptchaConfig } from "../types/captcha";

class SupportService {
  /**
   * Retrieves reCAPTCHA configuration
   *
   * Fetches the reCAPTCHA site key and other configuration
   * needed for client-side reCAPTCHA implementation.
   *
   * @returns Promise resolving to reCAPTCHA configuration
   */
  async getRecaptchaKey() {
    const { data } = await vbApiService.get<RecaptchaConfig>("config");
    return data;
  }

  /**
   * Submits a support request
   *
   * Sends user support requests/feedback to the backend.
   *
   * @param form - Support form data containing user message and details
   * @param header - Additional headers (typically reCAPTCHA token)
   *
   * @returns Promise resolving to submission result
   */
  async postSupport(
    form: Record<string, unknown>,
    header: Record<string, unknown>
  ) {
    return await vbApiService.post("support_request", form, {
      headers: {
        ...header,
        "Content-Type": "application/json",
      },
    });
  }
}

const supportService = new SupportService();

export default supportService;
